import { ROLES } from '../../features/authentication/authRoles.constants';

/**
 * Maps route paths (relative to the 'home' parent) to the role(s) required to access them.
 * The guard uses an OR check – access is granted when the user holds AT LEAST ONE of the listed roles.
 */
export const ROUTE_PERMISSIONS: Record<string, string[]> = {
  // ── Product Data ──────────────────────────────────────────────────────────
  'make': [ROLES.view_product, ROLES.edit_product],
  'preMold': [ROLES.view_product, ROLES.edit_product],
  'customMold': [ROLES.view_product, ROLES.edit_product],
  'disposalCharges': [ROLES.view_product, ROLES.edit_product],
  'finishedProduct': [ROLES.view_product, ROLES.edit_product],
  'casingSize': [ROLES.view_product, ROLES.edit_product],
  'casingDefinition': [ROLES.view_product, ROLES.edit_product],
  'casingFitment': [ROLES.view_product, ROLES.edit_product],
  'factoryCode': [ROLES.view_product, ROLES.edit_product],
  'adjustmentReasons': [ROLES.view_product, ROLES.edit_product],
  'application': [ROLES.view_product, ROLES.edit_product],
  'axle': [ROLES.view_product, ROLES.edit_product],
  'casingCredit': [ROLES.view_product, ROLES.edit_product],
  'casingPurchase': [ROLES.view_product, ROLES.edit_product],
  'freeRepair': [ROLES.view_product, ROLES.edit_product],
  'rerunReworkReasons': [ROLES.view_product, ROLES.edit_product],
  'rejectReasons': [ROLES.view_product, ROLES.edit_product],
  'casingGrade': [ROLES.view_casing_grade, ROLES.edit_casing_grade],
  'casing-grade-table': [ROLES.view_casing_grade, ROLES.edit_casing_grade],
  'casing-CreditRepair': [ROLES.view_product, ROLES.edit_product],
  'repairs': [ROLES.view_product, ROLES.edit_product],
  'wheelAndTireServices': [ROLES.view_services, ROLES.edit_services],
  'preferred-treads': [ROLES.view_product, ROLES.edit_product],
  // ── Setup Screens ─────────────────────────────────────────────────────────
  'plantSetup': [ROLES.plant_view, ROLES.plant_edit],
  'siteSetup': [ROLES.site_view, ROLES.site_edit],
  'dealerSetup': [ROLES.edit_dealer_setup],
  'zoneSetup': [ROLES.view_zone],
  'productImport': [ROLES.btn_admin],
  'pointOfSale': [ROLES.view_pos_interface, ROLES.edit_pos_interface],
  'emailSetup': [ROLES.manage_emails],
  // ── CAM Specifications ────────────────────────────────────────────────────
  'specifications': [ROLES.view_cams, ROLES.edit_cams],
  // ── Customers ─────────────────────────────────────────────────────────────
  'customers': [ROLES.view_customer, ROLES.edit_customer],
  // ── User Management ───────────────────────────────────────────────────────
  'usersetup': [ROLES.view_user, ROLES.edit_user, ROLES.view_user_group],
  // ── Work Orders ───────────────────────────────────────────────────────────
  'work-orders': [ROLES.view_work_orders, ROLES.create_work_orders, ROLES.edit_work_orders],
  // ── Inventory ─────────────────────────────────────────────────────────────
  'inventory': [ROLES.inventory_role],
  // ── Casing Search ─────────────────────────────────────────────────────────
  'search-casings': [ROLES.search],
  // ── Packlist ──────────────────────────────────────────────────────────────
  'packlist': [ROLES.search],
  // ── Administration ────────────────────────────────────────────────────────
  'administration': [ROLES.btn_admin]
};
